'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var NOTE_TYPES = ['default', 'primary', 'success', 'warning', 'danger'];

var FormNote = (function (_React$Component) {
    _inherits(FormNote, _React$Component);

    function FormNote() {
        _classCallCheck(this, FormNote);

        _get(Object.getPrototypeOf(FormNote.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(FormNote, [{
        key: 'render',
        value: function render() {
            // classes
            var componentClass = (0, _classnames2['default'])('FormNote', this.props.type ? 'FormNote--' + this.props.type : null, this.props.className);

            // props
            var props = (0, _blacklist2['default'])(this.props, 'className', 'note', 'type');

            // allow users to pass through the note as an attribute or as children
            return _react2['default'].createElement(
                'div',
                _extends({}, props, {
                    className: componentClass,
                    dangerouslySetInnerHTML: this.props.note ? { __html: this.props.note } : null
                }),
                this.props.children
            );
        }
    }]);

    return FormNote;
})(_react2['default'].Component);

FormNote.propTypes = {
    className: _propTypes2['default'].string,
    note: _propTypes2['default'].string,
    type: _propTypes2['default'].oneOf(NOTE_TYPES)
};

FormNote.defaultProps = {
    type: 'default'
};

module.exports = FormNote;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/FormNote.js
// module id = 967
// module chunks = 0 1